import React from 'react';
import SiteCharts from '../../../components/SiteCharts';
import { handinOverS1ChartConfig } from '../chartConfigs';

/**
 * Props for the HandinOverS1Echarts component
 */
interface HandinOverS1EchartsProps {
  /** Callback function to toggle fullscreen mode */
  onFullscreenToggle: () => void;
  /** Current fullscreen state */
  isFullscreen: boolean;
}

/**
 * Handin Over S1 Handover Success Rate Chart (LTE Site Level)
 * 
 * Displays S1 interface incoming handover metrics:
 * - Handin Over S1 Success (count)
 * - Handin Over S1 Attempt (count)
 * - Handin Over S1 Success Rate (percentage)
 * 
 * @component
 * @see {@link ../chartConfigs.ts} - Chart configuration (handinOverS1ChartConfig)
 * @see API: /api/lte/handin-over-s1?site_name={siteName}
 */

const HandinOverS1Echarts: React.FC<HandinOverS1EchartsProps> = ({ 
  onFullscreenToggle, 
  isFullscreen 
}) => {
  return (
    <SiteCharts 
      config={handinOverS1ChartConfig}
      onFullscreenToggle={onFullscreenToggle}
      isFullscreen={isFullscreen}
    />
  );
};

export default HandinOverS1Echarts;
